import clsx from 'clsx';
import styles from './Typography.module.scss';

type TypographyTag =
    | 'div'
    | 'span'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'small'
    | 'label';

export type TypographyStyle =
    | 'display-XL'
    | 'display-L'
    | 'display-M'
    | 'title-XL'
    | 'title-L'
    | 'title-M'
    | 'title-S'
    | 'title-XS'
    | 'paragraph-XXL'
    | 'paragraph-XL'
    | 'paragraph-L'
    | 'paragraph-M'
    | 'paragraph-S'
    | 'paragraph-XS'
    | 'disclaimer-M'
    | 'disclaimer-S'
    | 'textLink-L'
    | 'textLink-M'
    | 'textLink-S'
    | 'trumpet-XL';

type TypographyWeight = 'bold' | 'medium' | 'regular';

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
    /** The text to show */
    children?: React.ReactNode;
    /** The id of the element the label is for */
    htmlFor?: string;
    /** The html tag to be used for the typography */
    as?: TypographyTag;
    /** The typography styling to be used */
    variant?: TypographyStyle;
    /** The font weight styling to be used */
    weight?: TypographyWeight;
}

const weights: Record<TypographyWeight, string> = {
    bold: styles.isBold,
    medium: styles.isMedium,
    regular: styles.isRegular,
};

const Typography = ({
    children,
    className,
    as = 'span',
    variant = 'paragraph-XL',
    weight,
    ...rest
}: TypographyProps) => {
    const Tag = as;

    return (
        <Tag
            {...rest}
            className={clsx(
                styles.component,
                styles[variant],
                {
                    [weights[weight ?? 'regular']]: weight,
                },
                className,
            )}
        >
            {children}
        </Tag>
    );
};

export default Typography;
